var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate, useToastService } from '@lucidlink/uicore';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
import { GuestsKeyFactory } from '../query-key-factories/GuestsKeyFactory';
export const useRemoveGuestFromAllLinks = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const { addToast } = useToastService();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ email }) => plugFilespaceClient({
            action: (fsClient) => fsClient
                .guestLinksManagement()
                .removeGuestFromAllLinks(email),
            filespaceId,
            workspaceId,
        }),
        onError: (_, { email }) => {
            addToast({
                'data-testid': 'remove-guest-from-all-links-error',
                kind: 'negative',
                content: {
                    // The toast content is already PII-masked by ToastContent.
                    message: translate('Failed to remove guest {{email}} from all links', { email }),
                },
            });
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: GuestsKeyFactory.all({
                        filespaceId,
                        workspaceId,
                    }),
                }),
                queryClient.invalidateQueries({
                    queryKey: GuestLinkKeyFactory.all({
                        filespaceId,
                        workspaceId,
                    }),
                }),
            ]);
        },
        networkMode: 'always',
    });
    return mutation;
};
_react_refresh_temp_1(useRemoveGuestFromAllLinks, "KrM3mhTkTlZAjWS6DCmlJKC0EYA=", false, () => [usePlugFilespaceClient, useToastService, useQueryClient, useMutation]);
